/**
 * App Reducer
 *
 * Fetch Me - React Native
 * Ashan Beruwalage <ashan@interlective.com>
 * https://bitbucket.org/interlective/fetch-me-react-native
 */

// Set initial state

export const initialState = {
    theme_name: '',
    language: "en",
    languages: ["en"],
    isLoading: false,
    bmos:[],
    industries:[],
    countries:[],
    regions:[],
    faq_categories:[],
    settings: {},
    tags:[]
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case "APP_SET_LANGUAGE":
            return {
                ...state,
                language: action.language
            };
        case "APP_SET_LANGUAGES":
            return {
                ...state,
                languages: action.languages
            };
        case "APP_SET_THEME":
            return {
                ...state,
                theme_name: action.theme_name
            };
        case "APP_LOADING":
            return {
                ...state,
                isLoading: action.Loading
            };
            case "APP_SET_REGIONS":
                return {
                    ...state,
                    regions: action.regions
                };
        case "APP_SETCOMMON_DATA":
                return {
                    ...state,
                    bmos: action.bmos,
                    industries:action.industries,
                    countries:action.countries,
                    faq_categories:action.faq_categories,
                    settings:action.settings,
                    tags:action.tags
                };
        default:
            return state;
    }
}
